import { render, staticRenderFns } from "./DatosAsamblea.vue?vue&type=template&id=91fa0bcc&scoped=true"
import script from "./DatosAsamblea.vue?vue&type=script&lang=js"
export * from "./DatosAsamblea.vue?vue&type=script&lang=js"
import style0 from "./DatosAsamblea.vue?vue&type=style&index=0&id=91fa0bcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa0bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91fa0bcc')) {
      api.createRecord('91fa0bcc', component.options)
    } else {
      api.reload('91fa0bcc', component.options)
    }
    module.hot.accept("./DatosAsamblea.vue?vue&type=template&id=91fa0bcc&scoped=true", function () {
      api.rerender('91fa0bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/infoBase/DatosAsamblea.vue"
export default component.exports